<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini pos-relative c-portlet_box_specs">
    <div class="c-portlet__content analytics-portlet-content">
        <div>
            <div class="report-section">
                <div class="attributes-section">
                    <h2 class="header-section">Attributes</h2>
                    <div class="atrributes-search-section">
                        <div class="search-input-contanier">
                            <i class="search-icon fa fa-search"></i>
                            <input type="text" class="search-input ng-pristine ng-valid ng-touched" [(ngModel)]="searchAttribute"
																	 placeholder="Start typing to search attributes to be added to your report..."
                                 focusDirective (onFocusOut)="onSearchFocus('attribute')" (keypress)="onSearchFocus('attribute')">
                        </div>
                        <div class="search-section" *ngIf="showAtrributes" #searchSection>
                            <div class="search-div">
                                <i class="search-icon-in-popup fa fa-search"></i>
                                <input type="text" class="ng-pristine ng-valid ng-touched" [(ngModel)]="searchAttribute" placeholder="Start typing to search attributes to be added to your report...">
                            </div>
                            <div class="attributes-section">
	                            <ul>
		                            <li *ngFor="let attribute of attributes | searchReportAttributesPipe : searchAttribute" class="pure-checkbox">
			                            <input type="checkbox" id="attr_{{attribute.key}}" class="report-attr-checkbox" [checked]="attribute.selected" [(ngModel)]="attribute.selected"
			                                   (change)="addToSelectedAttributeList(attribute)" />
			                            <label for="attr_{{attribute.key}}" data-size="regular">
				                            {{attribute.friendlyName}}
			                            </label>
		                            </li>
	                            </ul>
                            </div>
                        </div>
                        <div class="selected-attributes-section">
                            <ul [sortablejs]="selectedAttributes" [sortablejsOptions]="draggableOptions">
                                <li [class.draggable]="true" *ngFor="let attribute of selectedAttributes">
                                    {{attribute.friendlyName}}
                                    <span (click)="removeSelectedAttribute(attribute)">X</span>
                                </li>
                            </ul>
                        </div>
                        <div class="drag-info">
                            <i class="fa fa-arrows"></i>
                            <span>&nbsp;Attributes can be arranged by dragging and dropping</span>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="attributes-section">
                    <h2 class="header-section">Metrics</h2>
                    <div class="atrributes-search-section">
                        <div class="search-input-contanier">
                            <i class="search-icon fa fa-search"></i>
                            <input type="text" class="search-input ng-pristine ng-valid ng-touched" [(ngModel)]="searchMetric" placeholder="Start typing to search metrics to be added to your report..."
                                (keypress)="onSearchFocus('metrics')" focusDirective (onFocusOut)="onSearchFocus('metrics')">
                        </div>
                        <div class="search-section" *ngIf="showMetrics" #metricSection>
                            <div class="search-div">
                                <i class="search-icon-in-popup fa fa-search"></i>
                                <input type="text" class="search-input-in-popup ng-pristine ng-valid ng-touched" [(ngModel)]="searchMetric" placeholder="Start typing to search metrics to be added to your report...">
                            </div>
                            <div class="attributes-section">
	                            <ul>
		                            <li *ngFor="let metric of metrics | searchReportAttributesPipe : searchMetric" class="pure-checkbox">
			                            <input type="checkbox" id="attr_{{metric.key}}" class="report-attr-checkbox" [checked]="metric.selected" [(ngModel)]="metric.selected"
			                                   (change)="addToSelectedMetricsList(metric)" />
			                            <label for="attr_{{metric.key}}" data-size="regular">
				                            {{metric.friendlyName}}
			                            </label>
		                            </li>
	                            </ul>
                            </div>
                        </div>
                        <div class="selected-attributes-section">
                            <ul [sortablejs]="selectedMetrics" [sortablejsOptions]="draggableOptions">
                                <li [class.draggable]="true" *ngFor="let metric of selectedMetrics">
                                    {{metric.friendlyName}}
                                    <span (click)="removeSelectedMetric(metric)">X</span>
                                </li>
                            </ul>
                        </div>
                        <div class="drag-info">
                            <i class="fa fa-arrows"></i>
                            <span>&nbsp;Metrics can be arranged by dragging and dropping</span>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="float-right">
                <button class="c-button primary-color-bg u-font_Padding report-btn" (click)="generateCustomReport()">
                    Generate Report
                </button>
            </div>
        </div>
    </div>
    <div class="clear"></div>
</div>

<app-modal id="custom-reports-widget-error" [closeOnBackground]="false">
    <div class="modal">
        <div class="modal-body">
            <div class="modal-header primary-color-border-bottom">
                Generate Report
            </div>
            <div class="modal-content">
                <div *ngIf="validationMessages.length > 0; else generateEmailBlock">
                    <ul>
                        <li class="validation-message" *ngFor="let validationMessage of validationMessages">
                            {{validationMessage}}
                        </li>
                    </ul>
                </div>
                <ng-template #generateEmailBlock>
                    <div class="validation-message">
                        {{emailConfirmationMessage}}
                    </div>
                </ng-template>
            </div>
            <div class="modal-footer">
                <div class="float-right">
                    <button class="c-button primary-color-bg u-font_Padding report-btn" (click)="closeModal('custom-reports-widget-error')">Cancel
                    </button>
                    <button *ngIf="showEmailConfirmation" id="email-report" class="c-button primary-color-bg u-font_Padding report-btn">Email Me
                    </button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
    <div class="modal-background"></div>
</app-modal>
